import { defineMessages } from 'react-intl';

const parishBookMessages = defineMessages({
    subgroupReadOnlyTooltip: {
        id: 'parishBook.subgroupReadOnlyTooltip',
        defaultMessage: 'Księga parafialna jest zarządzana w parafii nadrzędnej. W podgrupie możesz tylko przeglądać jej dane.',
    },
    subgroupReadOnlyDescription: {
        id: 'parishBook.subgroupReadOnlyDescription',
        defaultMessage: 'Dane pochodzą z parafii nadrzędnej i w tej podgrupie są tylko do odczytu.',
    },
});

export default parishBookMessages;
